export default {
  data() {
    return {
      currentYear: new Date().getFullYear(),
      currentDate: new Date().toISOString().split('T')[0],
    };
  },
  methods: {
    formatDate(dateString) {
      if (!dateString) return ""; // Handle empty values
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return "Invalid Date"; // Handle invalid dates
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const year = date.getFullYear();
      return `${month}/${day}/${year}`;
    },
    formatTime(timeString) {
      if (!timeString) return "Invalid Time"; // Handle empty values
  
      const [hour, minute] = timeString.split(":").map(Number);
      if (isNaN(hour) || isNaN(minute)) return "Invalid Time"; // Handle invalid time
  
      const period = hour >= 12 ? "PM" : "AM";
      const formattedHour = hour % 12 || 12; // Convert 0 to 12 for 12 AM
  
      return `${formattedHour}:${String(minute).padStart(2, "0")} ${period}`;
    }
  },
};